import React from 'react';
import classNames from 'classnames';

import { DynamicMediaItem } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import {
  Text,
} from '../../../components';

import { ParagraphTextMedia as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphTextMediaProps {
  entity: ImmutableEntity<Type>;
}

const DEFAULT_ASPECT_RATIO = '4_3';

const ParagraphTextMedia: React.FC<ParagraphTextMediaProps> = ({
  entity,
}) => {
  const paragraphTextMedia = entity.toJS();

  const label = paragraphTextMedia.field_label[0]?.value;
  const title = paragraphTextMedia.field_title[0]?.value;
  const body = paragraphTextMedia.field_body[0].processed || '';
  const link = paragraphTextMedia.field_link[0];
  const linkTitle = link?.title;
  const linkUri = link?.alias || link?.uri;
  const linkTarget = link?.options?.attributes?.target;
  const secondaryLink = paragraphTextMedia.field_link_secondary[0];
  const secondaryLinkTitle = secondaryLink?.title;
  const secondaryLinkUri = secondaryLink?.alias || secondaryLink?.uri;
  const secondaryLinkTarget = secondaryLink?.options?.attributes?.target;
  const alignment = paragraphTextMedia.field_alignment[0]?.value;
  const media = paragraphTextMedia.field_media_item[0];
  const aspectRatio = paragraphTextMedia.field_aspect_ratio[0]?.value;

  const caption = media.entity.field_caption[0]?.value;
  const isVideo = media.bundle === 'video' || media.bundle === 'remote_video';

  const alignmentTop = alignment === 'top';
  const alignmentLeft = alignment === 'left';
  const alignmentRight = alignment === 'right';

  const containerClass = classNames('row', {
    'ParagraphTextMedia--flipped': alignmentLeft,
    'ParagraphTextMedia--top': alignmentTop,
  });
  const subClassImage = classNames({
    'col-12': alignmentTop,
    'col-12 col-md-6 col-lg-5': alignmentLeft,
    'col-12 col-md-6 col-lg-5 offset-lg-1': alignmentRight,
  });
  const subClassText = classNames({
    'col-12': alignmentTop,
    'col-12 col-lg-8 col-xl-7': isVideo && alignmentTop,
    'col-12 col-md-6 offset-lg-1': alignmentLeft,
    'col-12 col-md-6': alignmentRight,
  });

  return (
    <div className="Paragraph ParagraphTextMedia">
      <Container small={isVideo ? false : alignmentTop}>
        <div className={containerClass}>
          <div className={subClassText}>
            {label && (
              <p className="ParagraphTextMedia__label">
                {label}
              </p>
            )}
            <Text
              label={label}
              title={title}
              text={body}
              link={linkUri}
              linkText={linkTitle}
              buttonClassName="icon-after icon-arrow-right icon-variant-1"
              target={linkTarget}
              secondaryLink={secondaryLinkUri}
              secondaryLinkText={secondaryLinkTitle}
              secondaryTarget={secondaryLinkTarget}
              secondaryButtonClassName="Button--textual icon-after icon-arrow-right"
              secondaryButtonPrimary={false}
            />
          </div>

          <div className={subClassImage}>
            {media && (
              <DynamicMediaItem
                media={media}
                caption={caption}
                imageAspectRatio={!aspectRatio ? DEFAULT_ASPECT_RATIO : aspectRatio}
              />
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphTextMedia;
